export const portfolioData = {
  personal: {
    name: "Aditya Kumar Singh",
    title: "Flutter Developer",
    tagline: "Building Beautiful Mobile Experiences",
    location: "Ambala City, Haryana",
    email: "adityakumars064@gmail.com",
    linkedIn: "https://www.linkedin.com/in/adityakumars064/",
  
    github: "https://github.com/adityaaks/",
    phone: "+91-8168724284",
    summary: "Experienced Flutter developer with 4+ years of hands-on experience in designing, developing and deploying mobile applications on both iOS and Android platforms. Proficient in implementing UI designs using Flutter widgets and packages. Skilled in using Dart programming language and integrating APIs to build scalable and robust applications.",
    languages: ["English", "Hindi", "Punjabi"],
    hobbies: ["Mobile Photography", "Listening Music", "Gaming"]
  },
  
  experience: [
    {
      id: 1,
      company: "Virtual Employee Pvt. Ltd.",
      role: "Software Engineer (Flutter Developer)",
      duration: "August 2025 - Present",
      responsibilities: [
        "Developed a mobile application that allows users to report crashes, police checkpoints, or hazards on an interactive map, enabling nearby tow truck drivers to quickly reach the incident location and provide timely assistance.",
        "Implemented a complete turn-by-turn Navigation module, integrating real-time routing, location tracking, and map-based guidance for tow truck drivers.",
        "Took ownership of an escalated project from a team member, resolved critical issues, and successfully delivered the module within the deadline while meeting all expected requirements and quality standards."
      ]
    },
    {
      id: 2,
      company: "Esferasoft Solutions Pvt. Ltd.",
      role: "Flutter Developer",
      duration: "April 2024 - August 2025",
      responsibilities: [
        "Developed a Flutter Flow-based mobile application that connects to BLE (Bluetooth Low Energy) devices via Bluetooth, supporting data read and write operations.",
        "Integrated group chat and personal chat using sockets.",
        "Integrated Video Player, Audio Player with mini player and Background Controls Handling.",
        "Developed functionality to fetch and store location data and speed in GPX files, both in the foreground and background."
      ]
    },
    {
      id: 3,
      company: "Webguruz Technologies Pvt. Ltd.",
      role: "Flutter Developer",
      duration: "June 2023 - April 2024",
      responsibilities: [
        "Developed a dynamic survey app to display dynamic forms, enabling users to fill out surveys offline with local database storage and sync data with the server once an internet connection is re-established.",
        "Integrated group chat and personal chat using sockets, and implemented game activity feature like goal, yellow card, timeout etc. in Football related application.",
        "Developed functionality to fetch and store location data and speed in GPX files, both in the foreground and background."
      ]
    },
    {
      id: 4,
      company: "Toxsl Technologies Pvt. Ltd.",
      role: "Software Engineer (Flutter)",
      duration: "January 2022 - June 2023",
      responsibilities: [
        "Developed and designed multiple applications, including Real Estate, Job Assignment, Service Booking, and Car Rental applications.",
        "Implemented various 3rd party APIs, Push Notifications, Social Login, and have experience with UI design and API implementation using Getx State Management.",
        "Integrated payment methods to ensure a seamless user experience.",
        "Learned to implement APIs and use Flutter packages."
      ],
      achievement: "Awarded 'Rising Star' for the Quarter (January-March 2022)"
    }
  ],
  
  education: [
    {
      id: 1,
      institution: "Rayat Bahra University, Mohali",
      degree: "Bachelor of Technology",
      field: "Computer Science Engineering",
      duration: "2018 - 2022",
      percentage: "74.6%"
    },
    {
      id: 2,
      institution: "Govt Sr. Sec. School, Prem Nagar",
      degree: "Senior Secondary (XII)",
      field: "Science",
      duration: "2018",
      percentage: "53.00%"
    },
    {
      id: 3,
      institution: "Police DAV Public School, Ambala City",
      degree: "Secondary (X)",
      duration: "2016",
      percentage: "8.20/10 CGPA"
    }
  ],
  
skills: [
  { name: "Flutter", category: "framework" },
  { name: "Dart", category: "language" },
  { name: "GetX State Management", category: "framework" },
  { name: "Bloc State Management", category: "framework" },
  { name: "Cross-Platform iOS & Android Development", category: "framework" },
  { name: "Flutter Flavors", category: "integration" },
  { name: "Localization (Multi-Language Support)", category: "integration" },
  { name: "Flutter Flow", category: "tool" },
  { name: "Firebase", category: "backend" },
  { name: "Socket", category: "integration" },
  { name: "Pusher", category: "integration" },
  { name: "RESTful API Integration", category: "integration" },
  { name: "Bluetooth Low Energy (BLE)", category: "integration" },
  { name: "ML Kit", category: "integration" },
  { name: "Text-to-Speech (TTS)", category: "integration" },
  { name: "Map Navigation SDK", category: "integration" },
  { name: "Real-Time Location Tracking", category: "integration" },
  { name: "GPX Location Tracking", category: "integration" },
  { name: "Stripe", category: "integration" },
  { name: "Razorpay", category: "integration" },
  { name: "PayPal", category: "integration" },
  { name: "Payment Gateway", category: "integration" },
  { name: "In-App Purchase", category: "integration" },
  { name: "Push Notifications", category: "integration" },
  { name: "Social Login (OAuth)", category: "integration" },
  { name: "SQLite", category: "database" },
  { name: "Git", category: "tool" },
  { name: "App Store & Google Play Deployment", category: "tool" },
  { name: "Agile / Scrum", category: "tool" }
],

  
  projects: [
    {
      id: 1,
      name: "Mines Transport Tracking",
      description:
        "A secure digital enforcement application built for the Government of Haryana to prevent illegal mining and eliminate Ravana (weighment) duplicacy. Delivered in coordination with DIO, Yamuna Nagar, Haryana and the Dept. of IT, Electronics & Communication, Haryana.",
      technologies: ["Flutter", "GetX", "REST API"],
      playStoreLink: "https://play.google.com/store/apps/details?id=com.app.mines_transport_tracking&hl=en_IN",
      appStoreLink: "https://apps.apple.com/in/app/minestransporttracking/id6760101532",
      status: "Live"
    },
    {
      id: 2,
      name: "Oldies Eyes",
      description:
        "An accessibility app that turns a smartphone into a talking magnifying glass — auto-scanning printed text (menus, labels, letters) and reading it aloud with synchronized word highlighting and multi-language translation, designed for seniors and users with vision impairment.",
      technologies: ["Flutter", "Node.js", "ML Kit", "Text-to-Speech"],
      playStoreLink: "https://play.google.com/store/apps/details?id=com.app.oldies_eye&pcampaignid=web_share",
      appStoreLink: "https://apps.apple.com/in/app/oldies-eyes/id6758658853",
      status: "Live"
    },
    {
      id: 3,
      name: "Link 2 Instructor",
      description:
        "A driving-instructor business platform for managing lesson bookings, calendar-based availability, in-app messaging, payments, and income tracking.",
      technologies: ["Flutter", "Node.js"],
      appStoreLink: "https://apps.apple.com/in/app/link-2-instructor/id6764334328",
      status: "Live"
    },
    {
      id: 4,
      name: "Link 2 Learner",
      description:
        "A driving-lesson booking app connecting learners with instructors for scheduling, secure prepayment, in-app messaging, and progress tracking toward their driving test.",
      technologies: ["Flutter", "Node.js"],
      appStoreLink: "https://apps.apple.com/in/app/link-2-learner/id6764585328",
      status: "Live"
    },
    {
      id: 5,
      name: "Nourish Mama",
      description:
        "A women-focused health and nutrition application that delivers AI-driven meal recommendations based on individual health goals. Users can scan meals using their camera to instantly receive detailed nutritional insights and values.",
      technologies: ["Flutter", "Python", ],
      appStoreLink: "https://apps.apple.com/in/app/nourish-mama/id6746253205",
      status: "Live"
    },
    {
      id: 6,
      name: "Run Against Drugs – Yamuna Nagar",
      description:
        "An official marathon registration platform built for the District Administration, Yamuna Nagar, Haryana — processing 1.25+ lakh registrations with Razorpay payment integration for 10km category entries, admin reporting, and downloadable e-certificates for participants.",
      technologies: ["Web", "Razorpay"],
      websiteLink: "https://runagainstdrugsynr.in/",
      status: "Live"
    },
    {
      id: 9,
      name: "Run Against Drugs – Rewari",
      description:
        "A companion marathon registration platform for the District Administration, Rewari, Haryana, replicating the Yamuna Nagar system — processing 80,000+ registrations with Razorpay payments for 10km category entries, admin reporting, and downloadable e-certificates.",
      technologies: ["Web", "Razorpay"],
      websiteLink: "https://www.runagainstdrugsrwr.in/",
      status: "Live"
    },
    {
      id: 10,
      name: "Football Performance Tracking App",
      description:
        "An application designed for parents and coaches to track children’s performance in local football tournaments when they are unable to attend in person. The app provides live community score updates, real-time match activities, and interactive team engagement features.",
      technologies: ["Flutter", "Node.js"],
      status: "Live"
    },
    {
      id: 11,
      name: "Health Sector App",
      description:
        "A healthcare management application that enables users to choose hospitals, select doctors, and book appointments at their preferred time slots. The app also allows users to view and download receipts, appointment details, and medical documents, as well as manage dependent profiles.",
      technologies: ["Flutter", "PHP"],
      status: "Live"
    },
    {
      id: 12,
      name: "Navigation & Incident Reporting App",
      description:
        "A mobile application featuring in-app Google Maps navigation that enables users to report road incidents and crashes. Tow truck drivers in affected regions receive real-time notifications and can respond promptly to reported incidents.",
      technologies: ["Flutter", "Node.js", "Google Maps"],
      status: "Live"
    }
  ]
};